import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Client } from './client';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  public allClients: Client[] = [];
  
  constructor(private http: HttpClient) {
  }

  getClients() {
    return this.http.get('/api/portal/clients');
  }
}
